var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"es-text-component",class:_vm.options.classes},[_c('content-editable',{model:{value:(_vm.options.text),callback:function ($$v) {_vm.$set(_vm.options, "text", $$v)},expression:"options.text"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }